module.exports = __webpack_public_path__ + "media/images/massage/card-desktop@2x-7d31d9c08b60334ef6d31377d9431c1c.jpg";